import { render, staticRenderFns } from "./smartO_knowledge.vue?vue&type=template&id=6e573e07&scoped=true"
import script from "./smartO_knowledge.vue?vue&type=script&lang=js"
export * from "./smartO_knowledge.vue?vue&type=script&lang=js"
import style0 from "./smartO_knowledge.vue?vue&type=style&index=0&id=6e573e07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e573e07",
  null
  
)

export default component.exports